import { getSessionUuid, getTokenLocalStorage, getTokenSessionStorage } from '@config/storage';
import { SnackType } from '@models/common.model';
import { appendActionMessage } from '@redux/reducers/actionMessages.reducer';
import { setWolfieNewMessages } from '@redux/reducers/wolfie.reducer';
import { RootState, store } from '@redux/store';
import { waitForWolfieReady } from './waitForWolfieReady';

export enum ActivityType {
  PROCESS_DELETION = 'PROCESS_DELETION',
  STEP_DELETION = 'STEP_DELETION',
  SUBSTEP_DELETION = 'SUBSTEP_DELETION',
  PROCESS_DONE_CHECK = 'PROCESS_DONE_CHECK',
  PROCESS_UPDATE = 'PROCESS_UPDATE',
  CONTINUE_PENDING = 'CONTINUE_PENDING',
}

const trackUserActivity = async (
  activity: ActivityType,
  rememberMe: boolean = false,
  id?: string,
  parentId?: string,
): Promise<{ success: boolean; data?: any }> => {
  try {
    const token = rememberMe ? getTokenLocalStorage() : getTokenSessionStorage();
    const sessionUuid = getSessionUuid();
    const state: RootState = store?.getState();
    const organizationId = state?.organization?.organizationId;

    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}activity/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Session-Uuid': sessionUuid,
        'X-Organization-Id': organizationId || ''
      },
      body: JSON.stringify({ activity, id, parentId }),
    });

    const data = await response.json();

    // Check for both 'message' and 'wolfieMessage' fields from backend response
    const messageContent = data?.message || data?.wolfieMessage;

    if (messageContent) {
      const newMessages = messageContent.split('---').map((message: any) => ({
        role: 'assistant',
        content: message,
        id: Math.random().toString(36).slice(2, 20),
      }));
      // Wait for Wolfie to be ready before adding new messages
      await waitForWolfieReady();

      // Update Wolfie messages
      // TODO: THis needs TO BE ADJUSTED AS PER THE NEW MESSAGE STRUCTURE
      store.dispatch(setWolfieNewMessages([...newMessages]));
    }
    // Show notification if specified
    if (data?.notificationMessage) {
      store.dispatch(
        appendActionMessage({
          message: data.notificationMessage,
          type: SnackType.WARNING,
        }),
      );
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error tracking activity:', error);
    return { success: false };
  }
};

export default trackUserActivity;
